var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refresh-button",on:{"click":_vm.onRefreshClick}},[_c('img',{staticClass:"pointer",attrs:{"src":require("@/assets/img/ui/refresh.svg")}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastRefreshText),expression:"lastRefreshText"}]},[_vm._v("Refreshed "+_vm._s(_vm.lastRefreshText)+" ago")])])
}
var staticRenderFns = []

export { render, staticRenderFns }